import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { QcClearanceInfo } from './qc-clearance_info.entity';
import { QcClearanceInfoController } from './qc-clearance-info.controller';
import { QcClearanceInfoService } from './qc-clearance-info.service';
import { QCClearanceInfoRepository } from './repository/qc-clearance-info.repo';
import { FileUploadEntity } from './file-upload.entity';
import { FileUploadRepository } from './repository/file-upload-repo';
import { join } from 'path';
import * as fs from 'fs';
import { ServeStaticModule } from '@nestjs/serve-static';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
const filesDestination = join(__dirname, '../../../../upload-files/qc-clearance-files');
console.log("Checking directory:", filesDestination);
try {
  if (!fs.existsSync(filesDestination)) {
    fs.mkdirSync(filesDestination);
    console.log("Directory created:", filesDestination);
  } else {
    console.log("Directory already exists:", filesDestination);
  }
} catch (error) {
  console.error("Error creating directory:", error.message);
}


@Module({
  imports:[TypeOrmModule.forFeature([QcClearanceInfo, FileUploadEntity]),
  ServeStaticModule.forRootAsync({
    useFactory: () => {
      return [
        {
          rootPath: filesDestination,
          serveRoot: '/qcClearance',
          serveStaticOptions: {
            redirect: false,
            index: false,
          }
        }
      ]
    }
  }),
],
  controllers: [QcClearanceInfoController],
  providers: [QcClearanceInfoService,ApplicationExceptionHandler, QCClearanceInfoRepository,FileUploadRepository,GenericTransactionManager]
})
export class QCClearanceModule {}
